import { useCart } from '@hooks/useCart/useCart';
import { useApplyCoupon } from '@hooks/useApplyCoupon';
import { useRemoveCoupon } from '@hooks/useRemoveCoupon';
import { deriveAppliedCoupon } from '../coupon';
import type { CouponActions, UseCouponActionsOptions } from './useCouponActions.types';

export const useCouponActions = (sessionId: string, { onError }: UseCouponActionsOptions = {}): CouponActions => {
  const cartQuery = useCart(sessionId);
  const applyCouponM = useApplyCoupon(sessionId, { onError });
  const removeCouponM = useRemoveCoupon(sessionId, { onError });

  return {
    appliedCoupon: deriveAppliedCoupon(cartQuery.data),
    isApplyingCoupon: applyCouponM.isPending,
    isRemovingCoupon: removeCouponM.isPending,
    applyCoupon: applyCouponM.mutate,
    applyCouponAsync: applyCouponM.mutateAsync,
    removeCoupon: removeCouponM.mutate,
    removeCouponAsync: removeCouponM.mutateAsync,
  };
};
